import TAO_KOE from './_TAO_KOE.js';

const getDispatchUrl = function( pathname ) {
	if ( document.location.host.endsWith( '.local' ) ) {
		const url = new URL( pathname, TAO_KOE.MenuDomain || document.baseURI );
		return url.toString();
	}

	const url = new URL( pathname, document.baseURI );
	return url.toString();
};

export default getDispatchUrl;
